import { ImperfectiveVerb } from '../../types'

const ебашить: ImperfectiveVerb = {
  type: 'imperfective verb',
  infinitive: 'ебашить',
  imperativePluralSecondPerson: 'ебашьте',
  imperativeSingularSecondPerson: 'ебашь',
  indicativePastPlural: 'ебашили',
  indicativePastSingularFeminine: 'ебашила',
  indicativePastSingularMasculine: 'ебашил',
  indicativePastSingularNeuter: 'ебашило',
  indicativePresentPluralFirstPerson: 'ебашим',
  indicativePresentPluralSecondPerson: 'ебашите',
  indicativePresentPluralThirdPerson: 'ебашат',
  indicativePresentSingularFirstPerson: 'ебашу',
  indicativePresentSingularSecondPerson: 'ебашишь',
  indicativePresentSingularThirdPerson: 'ебашит',
}

export default ебашить
